import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { Divider, MenuItem } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { IComboRemessaStatus } from '@model/RemessaStatus';
import { IRemessaFilter } from '@services/RemessaService';
import React from 'react';

export type RemessaFilterProps = {
    filter: IFilter<IRemessaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    remessaStatusCombo: IComboRemessaStatus
}

export function RemessaFilter ({filter, isLoading, empresaCombo, remessaStatusCombo}: RemessaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        <Divider />
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <StringField
                        field={filter.fields.descricao}
                        label="Descrição"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}